module.exports = __webpack_public_path__ + "img/44.345004cb.jpg";